/**
 * @ngdoc directive
 * @name flowHeader
 * @module flowingly.runner.flow
 * @description  This component is used to display a flow summary.
 * @usage
 * ```
    <flow-header ng-click="$ctrl.onClickMethod({ id: $ctrl.flow.Id })" flow="$ctrl.flow" is-mobile="$ctrl.isMobile"></flow-header>
 * ``` 
 * ### Notes
 * See Also: https://bizflo.atlassian.net/wiki/display/TECH/Angular+Flow+Components
 * ### Properties
 * #### Inputs
 * * flow: the flow data to display (JSON)
 * * isMobile: show mobile view if set
 */

import { SharedAngular } from '@Client/@types/sharedAngular';
import { RunnerFlowsFormatterService } from '@Client/runner.services/flows.formatter';
import IntegrationState from '@Shared.Angular/@types/core/contracts/queryModel/webhook/integrationState';
import angular from 'angular';

angular.module('flowingly.runner.flow').component('flowHeader', {
  bindings: {
    flow: '<',
    isMobile: '<' //show mobile view if set
  },

  controller: [
    'runnerFlowsFormatter',
    'APP_CONFIG',
    function (
      runnerFlowsFormatter: RunnerFlowsFormatterService,
      APP_CONFIG: SharedAngular.APP_CONFIG
    ) {
      const $ctrl = this;

      if (!$ctrl.flow) {
        return;
      }

      $ctrl.showConfidentialFlowOption = APP_CONFIG.showConfidentialFlowOption;
      $ctrl.progress = $ctrl.flow.PercentageComplete;
      $ctrl.webhookIconPath = ASSETS_PATH + '/webhooks-icon.svg';
      $ctrl.flowHasProcessingWebhook =
        $ctrl.flow.IntegrationState === IntegrationState.Processing;

      // if converting to TS remember to replace this with @TODO Guid.Empty
      if (
        $ctrl.flow.FlowId == '00000000-0000-0000-0000-000000000000' ||
        $ctrl.flow.FlowId == null
      ) {
        $ctrl.startedByText = 'Started by';
      } else {
        $ctrl.startedByText = runnerFlowsFormatter.getStartedByText($ctrl.flow);
      }

      updateFileIcon();

      function updateFileIcon() {
        let count = 0;
        if ($ctrl.flow.Steps) {
          for (let i = 0; i < $ctrl.flow.Steps.length; i++) {
            const step = $ctrl.flow.Steps[i];
            for (let j = 0; j < step.Fields.length; j++) {
              const field = step.Fields[j];
              if (field.HasFiles) {
                count++;
              } else if (field.Type === 'table') {
                if (field.TableHasRows) {
                  const table = JSON.parse(field.Text);
                  angular.forEach(table.rows, function (row) {
                    angular.forEach(row.cells, function (cell) {
                      if (cell.type === 4) {
                        if (cell.value) {
                          count++;
                        }
                      }
                    });
                  });
                }
              }
            }
          }
          $ctrl.flow.FilesCount = count;
        }
      }
    }
  ],
  controllerAs: '$ctrl',
  templateUrl:
    'Client/runner.flow/runner.flow.header/runner.flow.header.component.tmpl.html'
});
